import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { retrieveToken } from "../../../utils/storage";

export const magicViewApi = createApi({
  reducerPath: "magicView",
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_API_URL,
  }),
  endpoints: (builder) => ({
    getStatsDocs: builder.query({
      query: (userId) => ({
        url: "/admin/stats/docs", // Utilizza lo studioId nell'endpoint
        method: "GET",
        params: { userId },
        headers: {
          Authorization: `Bearer ${retrieveToken()}`,
        },
      }),
    }),
    getTableDocs: builder.query({
      query: (userId) => ({
        url: "/admin/stats/topcategories", // Utilizza lo studioId nell'endpoint
        method: "GET",
        params: { userId },
        headers: {
          Authorization: `Bearer ${retrieveToken()}`,
        },
      }),
    }),
  }),
});

export const {
  useGetStatsDocsQuery,
  useGetTableDocsQuery,
} = magicViewApi;
